/**
 * The confirm-time guard that the form on screen belongs to the session we are
 * about to confirm.
 *
 * Stripe treats `clientSecret` as immutable for the life of an `Elements`
 * group: hand a mounted group a second intent and the new secret is dropped
 * without a word, and the next confirm settles the *stale* intent. The surface
 * prevents that by keying the group on the secret, so a new one remounts. This
 * asserts that the prevention actually happened, at the one moment where being
 * wrong costs money.
 *
 * It compares the secret the group mounted with against the one the caller is
 * confirming, rather than reading the secret back off the `Elements` instance -
 * Stripe exposes no accessor for it, and a helper that reaches into a private
 * field would fail quietly on the next release, which is the failure mode this
 * exists to remove.
 */
export function assertMountedSecret(
  mountedSecret: string,
  intendedSecret: string,
): void {
  if (mountedSecret === intendedSecret) return;
  throw new Error(
    "The card form is showing a different payment session than the one being " +
      "confirmed. This is a bug: the form should have been remounted. " +
      "Refusing to confirm rather than charging the wrong session.",
  );
}
